<template>
  <a-layout id="components-layout-demo-side" style="min-height: 100vh">
    <template v-if="['/login', ''].includes(this.$route.path)">
      <router-view />
    </template>
    <template v-else>
      <!-- <a-layout-sider v-model="collapsed" collapsible> -->
      <a-layout-sider
        :style="{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
        }"
      >
        <div class="logo">
          <img src="@/assets/img/citylinelogolg.svg" alt="Cityline" />
        </div>
        <a-menu
          theme="dark"
          :selectedKeys="[$route.path]"
          mode="inline"
          class="text-left"
        >
          <template v-for="route in this.routeList">
            <a-menu-item
              :key="route.key"
              @click="onClick(route.path)"
              :class="
                $route.path === route.path ? 'ant-menu-item-selected' : ''
              "
            >
              <span>{{ route.label }}</span>
            </a-menu-item>
          </template>
        </a-menu>
      </a-layout-sider>
      <a-layout :style="{ marginLeft: '200px' }">
        <a-layout-header style="background: #fff; padding: 10 10">
          <a-row>
            <a-col :span="18"> </a-col>
            <a-col :span="5" class="text-right pr-2"> {{ currentUserLoginId }} </a-col>
            <a-col :span="1">
              <a
                href="javascript:void(0);"
                class="text-decoration text-primary"
                @click="onLogout"
                v-if="currentUserLoginId"
                ><strong>{{ $t("liveHeader.logout") }}</strong></a
              >
            </a-col>
          </a-row>
        </a-layout-header>
        <a-layout-content style="margin: 0 16px">
          <!-- <a-breadcrumb class="text-left" style="margin: 16px 0">
            <a-breadcrumb-item>User</a-breadcrumb-item>
            <a-breadcrumb-item>Bill</a-breadcrumb-item>
          </a-breadcrumb> -->
          <div
            :style="{
              padding: '24px',
              background: '#fff',
              minHeight: '360px',
            }"
          >
            <router-view />
          </div>
        </a-layout-content>
        <a-layout-footer style="text-align: center">
          <p class="text-primary">
            {{ $t("copyright.prefix") }} {{ currentYear }} {{ $t("copyright.suffix") }}
          </p>
        </a-layout-footer>
      </a-layout>
    </template>
  </a-layout>
</template>

<script>
import { getMemberProfile } from '@/utils/backend'
import Vue from 'vue'

export default {
  data () {
    return {
      collapsed: false,
      routeList: [],
      currentYear: new Date().getFullYear(),
      userProfile: null,
      currentUserLoginId: ''
    };
  },
  methods: {
    onClick: function (path) {
      this.$router.push(path);
    },
    onLogout () {
      localStorage.removeItem("cl_admin_role");
      this.$cookies.remove("cl_admin_token", null, '.cityline.com');
      this.$router.push("/login");
    },
    initMenu: function () {
      const roleType = this.$userProfile?.roleType
      if (roleType) {
        this.routeList = []
        for (let index = 0; index < this.$router.options.routes.length; index++) {
          const route = this.$router.options.routes[index];
          if (!(route.meta && route.meta.roles)) {
            continue
          }
          var targetRoute = JSON.parse(JSON.stringify(route))
          var skipNameList = ['Home', 'login', '404']
          if (!skipNameList.includes(route.name) && targetRoute.meta.roles.includes(roleType)) {
            targetRoute.key = index + 1
            this.routeList.push(targetRoute)
          }
        }

        var compare = function (obj1, obj2) {
          var val1 = obj1.label;
          var val2 = obj2.label;
          if (val1 < val2) {
            return -1;
          } else if (val1 > val2) {
            return 1;
          } else {
            return 0;
          }
        }
        this.routeList.sort(compare)

        for (let index = 0; index < this.routeList.length; index++) {
          var element = this.routeList[index];
          element.key = index + 1
        }
      }
    },
  },
  beforeUpdate () {
    getMemberProfile().then(res => {
      if (res.data) {
        // this.userProfile = res.data 
        this.currentUserLoginId = res.data.loginId
        Vue.prototype.$userProfile = res.data
        this.$userProfile = Vue.prototype.$userProfile
        localStorage.setItem("cl_admin_role", this.$userProfile.roleType);
      }

      if (!this.currentUserLoginId) {
        this.onLogout()
      }
    }).catch((error) => {
      console.log(error);
      this.onLogout()
    });
    this.initMenu()
    if (this.$route.path === '/404') {
      if (this.routeList.length > 0 && this.currentUserLoginId) {
        this.$router.push(this.routeList[0].path)
      } else {
        this.$router.push("/login");
      }
    }
  },
  mounted () {
    console.log("current version is 1.0.24")
    // console.log(['March', 'Jan', 'Feb', 'Dec', 'Da'].sort())
  }
};
</script>

<style>
#components-layout-demo-side .logo {
  background: rgba(255, 255, 255, 0.2);
  margin: 16px;
}
</style>
